import { query_view_2, query_view_1 } from './query';
import { COLUMNS_VIEW_1, COLUMNS_VIEW_2 } from './keys';
import DataTable from '../../../components/Datatable';
import CheckData from '../../../components/CatchError';
import LoadMoreComponent from '../../../components/LoadMoreComponent';
import ExtraButtons from './ExtraBtns';
import { getPercent } from '../../../helpers/showDelta';
import Search from '../../../components/Search';
import { scrollForTable } from '../../../components/Datatable/utils';
import { withTranslation } from 'react-i18next';

class Keywords extends LoadMoreComponent {
    constructor(props) {
        super();
        this.view_query = query_view_1;
        this.query = this.view_query({
            offset: 0,
            status: 'all',
            last_week: props.last_week,
            prior_week: props.prior_week,
            search: null,
        });
        this.offsetStep = 1000;

        this.onSelect = this.onSelect.bind(this);
        this.onRemoveAllSelected = this.onRemoveAllSelected.bind(this);
        this.getData = this.getData.bind(this);
        this.onChangeView = this.onChangeView.bind(this);
        this.onSearch = this.onSearch.bind(this);
    }

    searchFunction(data, search) {
        if (!search) return data;
        return data.filter((item) => item.keyword?.toLowerCase().includes(search.toLowerCase()));
    }

    async getData(value, search) {
        this.query = this.view_query({
            offset: 0,
            status: value,
            last_week: this.props.last_week,
            prior_week: this.props.prior_week,
            search: search ?? this.state.search,
        });
        this.query.bind(this.setState.bind(this));
        this.setState({ status: value, allData: [] });

        await this.query.update();
    }

    onChangeView(view) {
        if (view === 1) {
            this.view_query = query_view_1;
        } else {
            this.view_query = query_view_2;
        }
        this.setState({ view });
        this.getData('all');
    }

    onRemoveAllSelected(bool) {
        this.setState({
            removeAllSelected: bool,
            selectedItems: [],
        });
    }

    onSelect(action, state) {
        if (action.type === 'REMOVE_ALL') return this.setState({ selectedItems: [] });
        this.setState({ selectedItems: state.ids, removeAllSelected: false });
    }

    getTable() {
        switch (this.state.view) {
            case 2: {
                return {
                    columns: COLUMNS_VIEW_2(this.props.t),
                    tableStyles: `--data-table-library_grid-template-columns : minmax(60px, 0.5fr) minmax(200px, 1.2fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) !important; ${scrollForTable}`,
                    sortKey: 'sortFns_2',
                    defaultSortKey: 'clicks',
                    text: this.props.t('search.keywords.comparingWeeks', {
                        prior: this.props.prior_week,
                        last: this.props.last_week,
                    }),
                };
            }
            default: {
                return {
                    columns: COLUMNS_VIEW_1(this.props.t),
                    tableStyles: `--data-table-library_grid-template-columns : minmax(60px, 0.5fr) minmax(200px, 1.2fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(150px, 1.5fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) !important; ${scrollForTable}`,
                    sortKey: 'sortFns_1',
                    defaultSortKey: 'maxClicks',
                    text: null,
                };
            }
        }
    }

    onSearch(value) {
        this.setState({
            search: value,
        });
        this.getData(this.state.status, value);
    }

    render() {
        const { t } = this.props;
        const attr = {
            query: this.view_query,
            offsetStep: this.offsetStep,
            status: this.state.status,
            last_week: this.props.last_week,
            prior_week: this.props.prior_week,
            search: this.state.search,
        };

        const showLoadMoreBtn = this.state.data?.length === this.offsetStep;

        const sortFns = {
            sortFns_2: {
                keyword: (array) => array.sort((a, b) => a.keyword.localeCompare(b.keyword)),
                urls: (array) => array.sort((a, b) => a.urls - b.urls),
                urls_delta: (array) =>
                    array.sort(
                        (a, b) => getPercent(a.urls, a.urlsPrior) - getPercent(b.urls, b.urlsPrior),
                    ),
                clicks: (array) => array.sort((a, b) => a.clicks - b.clicks),
                clicks_delta: (array) =>
                    array.sort(
                        (a, b) =>
                            getPercent(a.clicks, a.clicksPrior) -
                            getPercent(b.clicks, b.clicksPrior),
                    ),
                impressions: (array) => array.sort((a, b) => a.impressions - b.impressions),
                impressions_delta: (array) =>
                    array.sort(
                        (a, b) =>
                            getPercent(a.impressions, a.impressionsPrior) -
                            getPercent(b.impressions, b.impressionsPrior),
                    ),
                position: (array) => array.sort((a, b) => a.position - b.position),
                position_delta: (array) =>
                    array.sort(
                        (a, b) =>
                            getPercent(a.position, a.positionPrior) -
                            getPercent(b.position, b.positionPrior),
                    ),
                ctr: (array) =>
                    array.sort((a, b) => a.clicks / a.impressions - b.clicks / b.impressions),
                ctr_delta: (array) =>
                    array.sort(
                        (a, b) => getPercent(a.ctr, a.ctrPrior) - getPercent(b.ctr, b.ctrPrior),
                    ),
            },
            sortFns_1: {
                keyword: (array) => array.sort((a, b) => a.keyword.localeCompare(b.keyword)),
                clicks: (array) => array.sort((a, b) => a.clicks - b.clicks),
                impressions: (array) => array.sort((a, b) => a.impressions - b.impressions),
                avgURLs: (array) => array.sort((a, b) => a.avgURLs - b.avgURLs),
                maxClicks: (array) => array.sort((a, b) => a.maxClicks - b.maxClicks),
                avgPosition: (array) => array.sort((a, b) => a.avgPosition - b.avgPosition),
                avgCTR: (array) =>
                    array.sort((a, b) => a.clicks / a.impressions - b.clicks / b.impressions),
            },
        };
        const extraBtns = () => (
            <ExtraButtons
                status={this.state.status}
                getData={this.getData}
                view={this.state.view}
                onChange={this.onChangeView}
                current_url={this.props.current_url}
                csrf_token={this.props.csrf_token}
                selectedItems={this.state.selectedItems?.map((id) => ({
                    id,
                    keyword: this.state.allData.find((item) => item.id === id).keyword,
                }))}
                onRemoveAllSelected={this.onRemoveAllSelected}
                t={t}
            />
        );

        const customeSearch = (
            <Search
                onSubmit={this.onSearch}
                placeholder={t('search.keywords.searchPlaceholder')}
                defaultValue={this.state.search}
            />
        );

        const { columns, tableStyles, sortKey, defaultSortKey } = this.getTable();
        return (
            <div className="card table-main rounded-main overflow-hidden">
                <div className="col-12">
                    <CheckData
                        content_id={this.props.content_id}
                        parent_id={this.props.parent_id}
                        data={this.state.allData}
                        loading={this.state.loading}
                        loadMore={this.state.loadMore}
                        customCheck
                        customCheckCondition={this.state.status !== 'all' || !!this.state.search}
                    >
                        <DataTable
                            nodes={this.state.allData}
                            sortFns={sortFns[sortKey]}
                            COLUMNS={columns}
                            fileName={t('search.keywords.header')}
                            header={t('search.keywords.header')}
                            additionalBox={extraBtns}
                            defaultSortKey={defaultSortKey}
                            searchFunction={this.searchFunction}
                            removeAllSelected={this.state.removeAllSelected}
                            hasSelect={true}
                            onSelect={this.onSelect}
                            forceRun={this.forceRun}
                            customeSearch={customeSearch}
                            showLoadMoreBtn={showLoadMoreBtn}
                            loadMoreLoading={this.state.loadMore}
                            loadMore={() => this.loadMore(attr)}
                            additionalStyles={{
                                Table: tableStyles,
                                BaseCell: ` font-family: 'Raleway';
                                            font-weight: 500;
                                            font-size: 16px;
                                            line-height: 19px;
                                            padding: 16px 10px !important;
                                            color: #0D182C;
                                        
                                        
                                            &.underline {
                                                text-decoration: underline;
                                            }
                                            `,
                            }}
                        />
                    </CheckData>
                </div>
            </div>
        );
    }
}

export default withTranslation()(Keywords);
